import "./LoginPage.css";

/**
 * LoginPage
 *
 * Shown in place of whatever page the user tried to visit while logged
 * out (Shell.jsx decides this after GET /api/auth/me comes back 401) -
 * same URL, so a deep link like /comp?stack=4 lands correctly once the
 * user signs in and Microsoft redirects back.
 *
 * Same navy hero / Fraunces wordmark as GatewayPage.jsx, so this reads as
 * the front door of the same product rather than a bolted-on auth screen.
 *
 * The button is a plain <a href="/auth/login"> - a real full-page browser
 * navigation, not a JS click handler. Flask owns the whole OAuth exchange
 * server-side (see backend/auth.py) and sets a session cookie; there is no
 * MSAL.js here and no token for the frontend to hold.
 */
export default function LoginPage() {
  return (
    <div className="lg-page">
      <div className="lg-inner">
        <div className="lg-brand">
          <img src="/potentiam_logo.png" alt="Potentiam" />
          <span className="lg-mark">Minerva<em>Intelligence</em></span>
        </div>

        <div className="lg-card">
          <h1 className="lg-title">Welcome to Minerva</h1>
          <p className="lg-sub">Sign in with your Potentiam account to continue.</p>

          <a href="/auth/login" className="lg-ms-btn">
            <svg viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M10.5 0L0 0V10.5H10.5V0Z" fill="#F25022" />
              <path d="M21 0L10.5 0V10.5H21V0Z" fill="#7FBA00" />
              <path d="M10.5 10.5L0 10.5V21H10.5V10.5Z" fill="#00A4EF" />
              <path d="M21 10.5L10.5 10.5V21H21V10.5Z" fill="#FFB900" />
            </svg>
            <span>Sign in with Microsoft</span>
          </a>

          <p className="lg-note">Secured with Microsoft Entra ID</p>
        </div>
      </div>
    </div>
  );
}
